import { render, staticRenderFns } from "./more-operate.vue?vue&type=template&id=6fcba6fa&scoped=true"
import script from "./more-operate.vue?vue&type=script&lang=js"
export * from "./more-operate.vue?vue&type=script&lang=js"
import style0 from "./more-operate.vue?vue&type=style&index=0&id=6fcba6fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcba6fa",
  null
  
)

export default component.exports